import { render, staticRenderFns } from "./CacheComponent.vue?vue&type=template&id=e489785c&scoped=true"
import script from "./CacheComponent.vue?vue&type=script&lang=js"
export * from "./CacheComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e489785c",
  null
  
)

export default component.exports